import * as React from "react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import PrwcBasicButton from "../../../../../../../ui/widgets/custom/buttons/PrwcBasicButton";
import PrwcTextButton from "../../../../../../../ui/widgets/custom/buttons/PrwcTextButton";
import PrwcDialog from "../../../../../../../ui/widgets/custom/PrwcDialog";
import BulkUsers from "../../presentations/BulkUsers";

type BulkUsersContainerProps = {
  isVisible: boolean;
  onHide: Function;
};

const BulkUsersContainer: React.FC<any> = (props: BulkUsersContainerProps) => {
  const { isVisible, onHide } = props;
  const { t } = useTranslation();
  const [bulkUsers, setBulkUsers] = useState(null);

  
  const handleFileUpload = (file: any) => {
    setBulkUsers(file);
  }

  const handleUpload = () => {
console.log(bulkUsers);
  }

  const renderFooter = () => {
    return (
      <div>
        <PrwcTextButton
          labelKey="generic.action.cancel"
          icon="pi pi-times"
          onClick={onHide}
          className="p-button-text p-button-sm"
        ></PrwcTextButton>
        <PrwcBasicButton
          type="button"
          labelKey="generic.action.upload"
          icon="pi pi-check"
          className="p-button-success p-button-sm"
          onClick={handleUpload}
        ></PrwcBasicButton>
      </div>
    );
  };

  return (
    <div>
      <PrwcDialog
        isVisible={isVisible}
        onHide={onHide}
        footer={renderFooter}
        header={t("users.label.bulkUpdateUsers")}
        modal={true}
      >
        <div className="w-full py-4 pr-4">
        <BulkUsers data={bulkUsers} onUpload={handleFileUpload}></BulkUsers>
        </div>
      </PrwcDialog>
    </div>
  );
};

export default BulkUsersContainer;
